import _ from 'lodash'
import JSEncrypt from 'jsencrypt'

export default {
  state: {
    user: typeof user === 'undefined' ? {} : user,
    page: typeof page === 'undefined' ? {} : page,
    cypher: null,
    publicRSA: null,
    cardData: {
      cardNumber: '',
      cardMonth: '',
      cardYear: '',
      cardCvv: '',
    },
  },
  mutations: {
    setEmailNotification(state, payload) {
      state.user = { ...state.user, email_notification: { ...state.user.email_notification, ...payload } }
    },
    setPublicRSA(state, payload) {
      state.publicRSA = payload
    },
    setCypher(state, payload) {
      state.cypher = payload
    },
    setCardData(state, cardData) {
      state.cardData = { ...state.cardData, ...cardData }
    },
    clearCardData(state) {
      state.cardData = {
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: '',
      }
      state.cypher = null
    },
  },
  actions: {
    generateCypher({ commit, state }) {
      const cardData = state.cardData

      // Validate card data first
      if (!cardData.cardNumber || !cardData.cardMonth || !cardData.cardYear || !cardData.cardCvv) {
        return false
      }

      const number = cardData.cardNumber.replace(/\s/g, '')
      const cd = `${number}|${cardData.cardMonth}/${cardData.cardYear}|${cardData.cardCvv}|${document.location.origin}`

      try {
        const decoded = Buffer.from(state.publicRSA, 'base64').toString('ascii')
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(decoded)
        const cypher = encrypt.encrypt(cd)

        commit('setCypher', cypher)
        return cypher
      } catch (error) {
        console.error('Cypher generation failed:', error)
        return false
      }
    },
    regenerateCypher({ dispatch, commit }) {
      commit('setCypher', null)

      return dispatch('generateCypher')
    },
  },
  getters: {
    isAuthenticated() {
      return true
    },
  },
}
